import { Component, effect, inject, signal } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { dateDebutDejaValideeValidator } from '@lib/validators/date-debut-deja-validee.validator';
import { DocumentsConsultantService } from '@lib/services/documents/documents-consultant.service';
import { PieceJustificativeDocumentTypeEnum } from '@graphql/generated';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';

const CERFA_3558_DOCUMENT_TYPES = [
  PieceJustificativeDocumentTypeEnum.Cerfa_3558Agc,
  PieceJustificativeDocumentTypeEnum.Cerfa_3558Pl,
  PieceJustificativeDocumentTypeEnum.Cerfa_3558Soc,
];

@Component({
  selector: 'app-document-form-cerfa-3558',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-cerfa-3558.component.html',
  styleUrl: './document-form-cerfa-3558.component.scss',
})
export class DocumentFormCerfa3558Component extends DocumentFormBase<Cerfa3558Form> {
  private readonly documentsConsultantService = inject(DocumentsConsultantService);
  private readonly datesDebutValidees = signal<string[]>([]);

  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  constructor() {
    super();
    this.form.controls.dateDebutValidite.addValidators(
      dateDebutDejaValideeValidator(this.datesDebutValidees)
    );

    // codeConsultant is only set when the document is editable
    effect(() => {
      if (this.codeConsultant()) {
        this.loadDatesDebutValidees();
      }
    });
  }

  override createForm(fb: NonNullableFormBuilder) {
    return createCerfa3558Form(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      this.form.get('dateFinValidite')?.setValue(undefined);
    }
  }

  private async loadDatesDebutValidees() {
    this.datesDebutValidees.set(
      await this.documentsConsultantService.getDatesDebutValiditeValidees(
        CERFA_3558_DOCUMENT_TYPES
      )
    );
    this.form.controls.dateDebutValidite.updateValueAndValidity();
  }
}

export function createCerfa3558Form(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type Cerfa3558Form = ReturnType<typeof createCerfa3558Form>;
export type Cerfa3558FormValue = Cerfa3558Form['value'];
